<template>
  <FormGroup :error="touched && !valid">
    <textarea
      ref="input"
      v-model="copy"
      class="row-modal__title-input"
      rows="1"
      :aria-label="field.name"
      :disabled="readOnly"
      :placeholder="$t('rowEditFieldTitle.placeholder')"
      @input="autoGrow"
      @keydown.enter.prevent="$refs.input.blur()"
      @focus="select()"
      @blur="unselect()"
    ></textarea>

    <template #error>
      <span v-show="touched && !valid">
        {{ error }}
      </span>
    </template>
  </FormGroup>
</template>

<script>
import rowEditField from '@baserow/modules/database/mixins/rowEditField'
import rowEditFieldInput from '@baserow/modules/database/mixins/rowEditFieldInput'

/**
 * Origem Flow: o campo primário é o título do modal da tarefa. Com o
 * <input> de uma linha do RowEditFieldText, título longo era cortado no meio
 * da palavra — aqui ele quebra em várias linhas, como no ClickUp. É um
 * textarea que cresce com o conteúdo, mas Enter continua confirmando (e não
 * insere quebra de linha), então o valor salvo segue sendo de uma linha só.
 */
export default {
  name: 'RowEditFieldTitle',
  mixins: [rowEditField, rowEditFieldInput],
  watch: {
    copy() {
      this.$nextTick(this.autoGrow)
    },
  },
  mounted() {
    this.autoGrow()
    if (typeof ResizeObserver !== 'undefined') {
      let previousWidth
      this.titleResizeObserver = new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width
        if (width !== previousWidth) {
          previousWidth = width
          this.autoGrow()
        }
      })
      this.titleResizeObserver.observe(this.$refs.input)
    }
  },
  beforeUnmount() {
    this.titleResizeObserver?.disconnect()
  },
  methods: {
    autoGrow() {
      const input = this.$refs.input
      if (!input) {
        return
      }
      // Zerar antes de medir: senão a altura só cresce, nunca diminui.
      input.style.height = 'auto'
      input.style.height = `${input.scrollHeight}px`
    },
  },
}
</script>
